const supplierReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default supplierReducer;